export default __webpack_public_path__ + "static/medgas_manifold_b.13cef4875e6a53cdf41c7a97f78b870c.svg";